import React, {useEffect, useState} from "react";
import { getIntroduction } from "../../service";
import {useLoading} from "../../components/loading/LoadingProvider";

function About() {

    const [textHtml,setTextHtml] = useState('')
    const loading = useLoading()

    useEffect(() => {
        loading.showLoading()
        getIntroduction().then(res => {
            if(res.code === 1){
                loading.hideLoading()
                setTextHtml(res.data.textContent)
            }else{
                loading.showError('无法获取数据')
            }
        })
    },[])

    return <div className="about-page">
        <div className="context" dangerouslySetInnerHTML={{ __html : textHtml }}/>
    </div>
}

export default About;
